import { IncarcerationStatus } from "src/types/UserStatus";

/**
 * Checks if a user is in custody (pre-release) based on their incarceration status.
 * In-custody users are pre-trial, sentenced, or transferred while detained.
 *
 * @param incarcerationStatus - The user's incarceration status
 * @returns true if the user is currently in custody
 */
export default function isInCustody(
  incarcerationStatus: keyof typeof IncarcerationStatus | undefined
): boolean {
  return (
    incarcerationStatus === "in_custody_sentenced" ||
    incarcerationStatus === "in_custody_pre_trial" ||
    incarcerationStatus === "in_custody_transferred"
  );
}
